import { CachingAdapterType } from './stores/adapter';

export const CACHE_ENABLED =
  (process.env.CACHE_ENABLED ?? 'true') === 'true' ||
  process.env.CACHE_ENABLED === '1';

export const CACHE_SQLITE_FILE =
  process.env.CACHE_SQLITE_FILE ?? '.next/tuic-cache.sqlite3';

export const CACHE_DEFAULT_TTL_SECONDS = parseInt(
  process.env.CACHE_DEFAULT_TTL_SECONDS ?? '600',
  10,
);

export const CACHE_DEFAULT_ADAPTER_PRIORITY: CachingAdapterType[] = [
  'sqlite',
  'memory',
  'redis',
];

export const CACHE_DEFAULT_ADAPTER: CachingAdapterType | undefined = process.env
  .CACHE_DEFAULT_ADAPTER as CachingAdapterType;

export const CACHE_REDIS_PREFIX = process.env.CACHE_REDIS_PREFIX ?? 'CACHE';

export const CACHE_REDIS_URL = process.env.REDIS_URL;

export const CACHE_ENABLE_HOT_SWAP =
  process.env.CACHE_ENABLE_HOT_SWAP === 'true';

export const CACHE_REPORT_TO_SENTRY =
  (process.env.CACHE_REPORT_TO_SENTRY ?? 'false') === 'true' ||
  process.env.CACHE_REPORT_TO_SENTRY === '1';
